export const ROLES = {
  SUPERVISOR: 'Supervisor',
  OPERATOR: 'Operator',
  CUSTOMER: 'Customer',
};

export const OWNER_ROLE = 'Owner';

export const ROLE_ACCESS: Record<string, number> = {
  [OWNER_ROLE]: 4,
  [ROLES.SUPERVISOR]: 3,
  [ROLES.OPERATOR]: 2,
  [ROLES.CUSTOMER]: 1,
};
